import { ReactNode } from 'react';
import { Box } from '@mui/material';

interface OfferGridProps {
  children: ReactNode;
  mb?: number;
}

export const OfferGrid = ({ children, mb = 0 }: OfferGridProps) => (
  <Box sx={{ 
    display: 'grid', 
    gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' }, 
    gap: 2,
    mb
  }}>
    {children}
  </Box>
);
